import script from "./ConfirmationReservation.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationReservation.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationReservation.vue?vue&type=style&index=0&id=7ff060c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff060c4"]])

export default __exports__